// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SummarySubscriptionFooter-module-smallText-gFbY-{font-size:12px;line-height:23px}.SummarySubscriptionFooter-module-sectionPrices-5A5pT{padding-top:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"smallText": "SummarySubscriptionFooter-module-smallText-gFbY-",
	"sectionPrices": "SummarySubscriptionFooter-module-sectionPrices-5A5pT"
};
export default ___CSS_LOADER_EXPORT___;
